import { Box, Button } from '@mui/material';
import useFetch from '../../../api/useFetch';
import moment from 'moment';
import { ExoTimeOverviewCal } from '../../../components/exo/ExoTimeOverviewCal';
import { DBRequest, useConfig } from '../../../api/api';
import { TimeLabelElement } from '../../time-manager/user-entries/timeline/TimeInfo';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import ExoDialog from '../../../components/exo/ExoDialog';
import NewVacation from '../../new-requests/NewVacation';
import { hasPermissions } from '../../../auth/hasPermissions';
import NewSick from '../../new-requests/NewSick';

export const EmployeeOverview = ({ employeeInfo, noPicture, own }) => {
  const config = useConfig();
  const { t } = useTranslation();

  const startDate = moment().startOf('M').format('YYYY-MM-DD');
  const endDate = moment().endOf('M').format('YYYY-MM-DD');
  const { apiData, setApiData } = useFetch(
    own
      ? `time-tracking/overview/own?period=day&startDate=${startDate}&endDate=${endDate}`
      : `users/${employeeInfo.id}/time-tracking/overview?period=day&startDate=${startDate}&endDate=${endDate}`
  );

  const [openVacation, setOpenVacation] = useState(false);
  const [openSick, setOpenSick] = useState(false);

  function handleChangePeriod(newStartDate, newEndDate) {
    if (!apiData) return;
    setApiData(null);
    DBRequest({
      config,
      path: own
        ? `time-tracking/overview/own?period=day&startDate=${newStartDate}&endDate=${newEndDate}`
        : `users/${employeeInfo.id}/time-tracking/overview?period=day&startDate=${newStartDate}&endDate=${newEndDate}`,
      onResponse: setApiData,
    });
  }
  const vacationRemaining =
    employeeInfo.vacationTotal - employeeInfo.vacationTaken;

  function handleChange(data) {
    const startDate = moment().startOf('M').format('YYYY-MM-DD');
    const endDate = moment().endOf('M').format('YYYY-MM-DD');

    handleChangePeriod(startDate, endDate);
    setOpenVacation(false);
    setOpenSick(false);
  }

  return (
    <Box className="w-full">
      {false && !own && (
        <Button
          variant="outlined"
          color="info"
          onClick={() => setOpenVacation(true)}
        >
          {t('Add vacation')}
        </Button>
      )}
      <Box className="flex justify-evenly pb-4 flex-wrap gap-2">
        <TimeLabelElement
          src={'/assets/uploads/times/account.webp'}
          label={t('Time Account')}
          totalTime={employeeInfo.timeAccount * 60}
          percent={1}
          hidePercent
          useFix
        />
        <TimeLabelElement
          onClick={() =>
            hasPermissions('employee-info', 'write') && setOpenVacation(true)
          }
          src={'/assets/uploads/times/vacation.webp'}
          label={t('Vacation available')}
          totalTime={employeeInfo.vacationTotal}
          percent={
            employeeInfo.vacationTotal !== 0
              ? 1 - employeeInfo.vacationTaken / employeeInfo.vacationTotal
              : 0
          }
          format="day"
          sufix={vacationRemaining > 1 ? t('Days') : t('Day')}
        />
        <TimeLabelElement
          onClick={() => setOpenSick(true)}
          src={'/assets/uploads/times/sick.webp'}
          label={t('Sick')}
          totalTime={employeeInfo.sickDaysTaken}
          percent={1}
          hidePercent
          format="day"
          sufix={t('Days')}
        />
      </Box>

      <ExoTimeOverviewCal
        times={apiData?.data.times}
        onChange={handleChangePeriod}
        activeTime={apiData?.data.activeTimeTracking}
      />

      <ExoDialog open={openVacation} onClose={() => setOpenVacation(false)}>
        <NewVacation
          onCancel={() => setOpenVacation(false)}
          onCreate={handleChange}
          userId={employeeInfo.id}
        />
      </ExoDialog>

      <ExoDialog open={openSick} onClose={() => setOpenSick(false)}>
        <NewSick
          onCancel={() => setOpenSick(false)}
          onCreate={handleChange}
          userId={employeeInfo.id}
        />
      </ExoDialog>
    </Box>
  );
};
